import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { LogGroup, Point, Size } from "../.././MyHelpers";
import { PlusOnePosition } from "./FreegamePlusOne";
import { Settings } from "../../Settings";
import { ISpinnableReels } from "../SpinAnimation/SpinnableReels";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import * as PIXI from "pixi.js";

export interface PlusOneParams { 
    viewSize:Size,
    spinnableReels:ISpinnableReels, 
    logGroup:LogGroup, 
    resid:ResourceIdentifier,
    bonusName:string,
    maxAdditionalFreegames : number, 
    gameBonusResourcesBasePath : string, 
    commonBonusResourcesBasePath : string,
}

export abstract class GenericPlusOne
{
    public constructor() {
    }
    protected commonResourcesBasePath: String = Settings.ResourcesFolder + "multigame/slot/common/resources/";
    public abstract Name(): String;
    public abstract View(): HTMLElement;
    public abstract Update(): void;
    public abstract Start(symbols: PlusOnePosition[], target: Point): void;
    public abstract Duration(): number;
    public abstract PrepareResources(resourceManager: IWriteOnlyResourceManager);
    public abstract ResourcesLoaded(resourceManager: IReadOnlyResourceManager);
     public abstract ResetCount();
    public abstract WillStartAnim() : boolean
}


export abstract class GenericPlusOnePIXIAPP extends GenericPlusOne
{    
    public constructor() {
        super();
    }
    public abstract ViewPIXIAPP() : PIXI.Container;
    public abstract CreatePIXAPP() : PIXI.Container;
    public abstract SetGlobalTarget(target: Point): void;
    public abstract StartPlusOnePIXIAPP(symbols: PlusOnePosition, target: Point): void;
}











